import script from "./AccountStatement.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountStatement.vue?vue&type=script&setup=true&lang=js"

import "./AccountStatement.vue?vue&type=style&index=0&id=042ec7ea&lang=css"

const __exports__ = script;

export default __exports__